// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"T0-z"};